import React from 'react';

const selectClass = 'w-full rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20';

const FundingAIAdvisorClientSelector = ({
  clients,
  value,
  onChange,
  loading,
}) => (
  <div>
    <label className="mb-1 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">
      Client scope
    </label>
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={selectClass}
      disabled={loading}
    >
      <option value="">Portfolio mode (agency-wide)</option>
      {(clients || []).map((client) => (
        <option key={client.id} value={client.id}>{client.name}</option>
      ))}
    </select>
  </div>
);

export default FundingAIAdvisorClientSelector;
